module.exports = __webpack_public_path__ + "img/inout.35df8bd4.png";